import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { saveConfig } from '@/api/settings';
import Sortable from 'sortablejs';
export default {
  props: {
    remoteColumnsList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    cacheName: {
      type: String,
      required: true,
      default: function _default() {
        return '';
      }
    }
  },
  components: {
    Sortable: Sortable
  },
  data: function data() {
    return {
      sortable: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                console.log('that.remoteColumnsList', that.remoteColumnsList);
                that.$nextTick(function () {
                  var el = document.querySelectorAll('.dropHeaderTable .el-table__body-wrapper > table > tbody')[0];
                  _this.sortable = new Sortable(el, {
                    onEnd: function onEnd(_ref) {
                      var newIndex = _ref.newIndex,
                          oldIndex = _ref.oldIndex;
                      var currRow = that.remoteColumnsList.splice(oldIndex, 1)[0];
                      that.remoteColumnsList.splice(newIndex, 0, currRow);
                      that.saveTableSet();
                    },
                    dragClass: 'dragClass',
                    ghostClass: 'ghostClass',
                    chosenClass: 'chosenClass'
                  });
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    saveTableSet: function saveTableSet() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                _context2.next = 3;
                return saveConfig({
                  key: that.cacheName,
                  value: JSON.stringify(that.remoteColumnsList)
                });

              case 3:
                that.$emit('save-table-set', that.remoteColumnsList);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};